class ProductSiblings extends HTMLElement {
  static observedAttributes = ["title", "product-id", "hide-current"];

  constructor() {
    super();
    console.log('Product Siblings: Started');
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // console.log(
    //   `Attribute ${name} has changed from ${oldValue} to ${newValue}.`,
    // );
    switch (name) {
      case "title" || "hide-current":
        if (newValue) {
          this.init(newValue);
        }
        break;

      case "product-id":
        if (/^\d+$/.test(newValue)) {
          this.currentId = +newValue
        }
        break;
    }
  }

  async init(newValue) {
    this.settings = {
      hideCurrent: this.getAttribute('hide-current') === "true" ? true : false
    }

    const query = `{
      products(first: 20, query:"title:${newValue}*") {
        edges {
          node {
            id
            title
            handle
            featuredImage {
              src
            }
          }
        }
      }
    }`;

    try {
      const req = await fetch(`https://thewndrr.myshopify.com/api/2025-04/graphql`, {
        method: "POST",
        headers: {
          "Content-Type": "application/graphql",
          "X-Shopify-Storefront-Access-Token": "f11d923f055859c3bf5d234f3a029755"
        },
        body: query
      });
      const res = await req.json();

      // console.log({ res, req })
      if (req.ok) {
        if (!res.data) {
          console.log('Product Siblings: Missing data. Please try again');
          return;
        }
        const { products: { edges: products } } = res.data;
        const filtered = products.filter(p => p.node.title.startsWith(newValue));

        if (filtered.length === 1 && this.settings.hideCurrent) {
          this.classList.add('hidden');
          return;
        }

        this.renderProducts(filtered);
      }
    } catch (error) {
      console.log('Product Siblings: Error in fetch. Please try again', { error });
    }
  }

  renderProducts(products = null) {
    if (!products) {
      this.handleError(res);
      return;
    }

    const productItems = products.map(item => {
      const { featuredImage, handle, title, id } = item.node;
      const pid = id.split('/').at(-1);
      const isCurrentProduct = +pid === this.currentId;
      let html = '';
      if (isCurrentProduct) {
        html = `
        <div class="product-card active${ this.settings.hideCurrent ? ' hidden' : ''}">
          <div class="v-stack justify-items-center gap-2">
            <img class="product-card__image product-card__image--primary  aspect-natural" src="${featuredImage.src}" alt="${title}" loading="lazy" />
            <span class="product-title text-center">${title.split(' - ').at(-1)}</span>
          </div>
        </div>
      `;
      } else {
        html = `
        <div class="product-card">
          <a href="/products/${handle}" class="v-stack justify-items-center gap-2">
            <img class="product-card__image product-card__image--primary  aspect-natural" src="${featuredImage.src}" alt="${title}" loading="lazy" />
            <span class="product-title text-center">${title.split(' - ').at(-1)}</span>
          </a>
        </div>
      `
      }
      return html;
    }).join('');

    const content = document.createElement('div');
    content.classList.add('product-siblings-wrapper');
    content.innerHTML = `
      <product-list class="floating-controls-container floating-controls-container--inside floating-controls-container--on-hover">
        <scroll-carousel id="product-sibling-el" class="product-list product-list--carousel scroll-area bleed md:unbleed is-scrollable" group-cells allow-drag>
          ${productItems}
        </scroll-carousel>
        <button is="carousel-prev-button" type="button" class="prev-next-button prev-next-button--prev circle-button hover:animate-icon-inline" aria-controls="product-sibling-el" disabled>
          <span class="sr-only">Previous</span>
          <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon-arrow-left icon--direction-aware" viewBox="0 0 16 18">
            <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"></path>
          </svg>
        </button>
        <button is="carousel-next-button" type="button" class="prev-next-button prev-next-button--next circle-button hover:animate-icon-inline" aria-controls="product-sibling-el">
          <span class="sr-only">Next</span>
          <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon-arrow-right icon--direction-aware" viewBox="0 0 16 18">
            <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
          </svg>
        </button>
      </product-list>
    `;

    this.appendChild(content);
  }
}
if (!customElements.get('product-siblings')){
  customElements.define('product-siblings', ProductSiblings);
}